import { CreditMap, ComparisonReport } from './types';

export const mockCreditMapAnterior: CreditMap = {
  id: 'map-2026-05',
  mes: 5,
  ano: 2026,
  mesLabel: 'Maio 2026',
  fileName: 'BdP_Mapa_Credito_Mai2026.xlsx',
  parsedAt: '2026-07-16T08:00:00Z',
  totalGeral: 4872340.50,
  institutions: [
    {
      id: 'inst-cgd',
      nome: 'Caixa Geral de Depósitos',
      totalEmDivida: 1245800.00,
      loans: [
        { id: 'loan-cgd-001', produtoFinanceiro: 'Crédito Habitação', inicio: '2018-03-15', fim: '2048-03-15', totalEmDivida: 485200.00 },
        { id: 'loan-cgd-002', produtoFinanceiro: 'Crédito Pessoal', inicio: '2022-06-01', fim: '2027-06-01', totalEmDivida: 28400.00 },
        { id: 'loan-cgd-003', produtoFinanceiro: 'Crédito Automóvel', inicio: '2023-01-10', fim: '2028-01-10', totalEmDivida: 18600.00 },
        { id: 'loan-cgd-004', produtoFinanceiro: 'Crédito Habitação', inicio: '2020-09-20', fim: '2050-09-20', totalEmDivida: 713600.00 },
      ],
    },
    {
      id: 'inst-bcp',
      nome: 'Millennium BCP',
      totalEmDivida: 987450.25,
      loans: [
        { id: 'loan-bcp-001', produtoFinanceiro: 'Crédito Habitação', inicio: '2019-07-01', fim: '2049-07-01', totalEmDivida: 612000.00 },
        { id: 'loan-bcp-002', produtoFinanceiro: 'Leasing Imobiliário', inicio: '2021-02-15', fim: '2036-02-15', totalEmDivida: 245000.00 },
        { id: 'loan-bcp-003', produtoFinanceiro: 'Crédito Pessoal', inicio: '2023-08-01', fim: '2026-08-01', totalEmDivida: 130450.25 },
      ],
    },
    {
      id: 'inst-novo',
      nome: 'Novo Banco',
      totalEmDivida: 756200.00,
      loans: [
        { id: 'loan-novo-001', produtoFinanceiro: 'Crédito Habitação', inicio: '2017-11-30', fim: '2047-11-30', totalEmDivida: 534500.00 },
        { id: 'loan-novo-002', produtoFinanceiro: 'Crédito Empresas', inicio: '2020-04-01', fim: '2030-04-01', totalEmDivida: 221700.00 },
      ],
    },
    {
      id: 'inst-sant',
      nome: 'Santander Portugal',
      totalEmDivida: 534890.75,
      loans: [
        { id: 'loan-sant-001', produtoFinanceiro: 'Crédito Habitação', inicio: '2021-05-15', fim: '2051-05-15', totalEmDivida: 398000.00 },
        { id: 'loan-sant-002', produtoFinanceiro: 'Crédito Automóvel', inicio: '2022-10-01', fim: '2027-10-01', totalEmDivida: 42890.75 },
        { id: 'loan-sant-003', produtoFinanceiro: 'Crédito Pessoal', inicio: '2024-01-20', fim: '2027-01-20', totalEmDivida: 94000.00 },
      ],
    },
    {
      id: 'inst-bpi',
      nome: 'Banco BPI',
      totalEmDivida: 623400.50,
      loans: [
        { id: 'loan-bpi-001', produtoFinanceiro: 'Crédito Habitação', inicio: '2016-06-01', fim: '2046-06-01', totalEmDivida: 489200.50 },
        { id: 'loan-bpi-002', produtoFinanceiro: 'Leasing Automóvel', inicio: '2023-03-01', fim: '2028-03-01', totalEmDivida: 67400.00 },
        { id: 'loan-bpi-003', produtoFinanceiro: 'Crédito Pessoal', inicio: '2024-07-15', fim: '2027-07-15', totalEmDivida: 66800.00 },
      ],
    },
    {
      id: 'inst-act',
      nome: 'Activobank',
      totalEmDivida: 312450.00,
      loans: [
        { id: 'loan-act-001', produtoFinanceiro: 'Crédito Habitação', inicio: '2020-12-01', fim: '2050-12-01', totalEmDivida: 278900.00 },
        { id: 'loan-act-002', produtoFinanceiro: 'Crédito Pessoal', inicio: '2025-01-10', fim: '2028-01-10', totalEmDivida: 33550.00 },
      ],
    },
    {
      id: 'inst-abk',
      nome: 'Abanca Portugal',
      totalEmDivida: 412149.00,
      loans: [
        { id: 'loan-abk-001', produtoFinanceiro: 'Crédito Habitação', inicio: '2019-08-20', fim: '2049-08-20', totalEmDivida: 356000.00 },
        { id: 'loan-abk-002', produtoFinanceiro: 'Crédito Empresas', inicio: '2022-03-15', fim: '2032-03-15', totalEmDivida: 56149.00 },
      ],
    },
  ],
};

export const mockCreditMapAtual: CreditMap = {
  id: 'map-2026-06',
  mes: 6,
  ano: 2026,
  mesLabel: 'Junho 2026',
  fileName: 'BdP_Mapa_Credito_Jun2026.xlsx',
  parsedAt: '2026-07-16T08:05:00Z',
  totalGeral: 4793215.80,
  institutions: [
    {
      id: 'inst-cgd',
      nome: 'Caixa Geral de Depósitos',
      totalEmDivida: 1223450.00,
      loans: [
        { id: 'loan-cgd-001', produtoFinanceiro: 'Crédito Habitação', inicio: '2018-03-15', fim: '2048-03-15', totalEmDivida: 483900.00 },
        { id: 'loan-cgd-002', produtoFinanceiro: 'Crédito Pessoal', inicio: '2022-06-01', fim: '2027-06-01', totalEmDivida: 27200.00 },
        { id: 'loan-cgd-003', produtoFinanceiro: 'Crédito Automóvel', inicio: '2023-01-10', fim: '2028-01-10', totalEmDivida: 17750.00 },
        { id: 'loan-cgd-004', produtoFinanceiro: 'Crédito Habitação', inicio: '2020-09-20', fim: '2050-09-20', totalEmDivida: 694600.00 },
      ],
    },
    {
      id: 'inst-bcp',
      nome: 'Millennium BCP',
      totalEmDivida: 965200.00,
      loans: [
        { id: 'loan-bcp-001', produtoFinanceiro: 'Crédito Habitação', inicio: '2019-07-01', fim: '2049-07-01', totalEmDivida: 609500.00 },
        { id: 'loan-bcp-002', produtoFinanceiro: 'Leasing Imobiliário', inicio: '2021-02-15', fim: '2036-02-15', totalEmDivida: 243200.00 },
        { id: 'loan-bcp-003', produtoFinanceiro: 'Crédito Pessoal', inicio: '2023-08-01', fim: '2026-08-01', totalEmDivida: 112500.00 },
      ],
    },
    {
      id: 'inst-novo',
      nome: 'Novo Banco',
      totalEmDivida: 739800.00,
      loans: [
        { id: 'loan-novo-001', produtoFinanceiro: 'Crédito Habitação', inicio: '2017-11-30', fim: '2047-11-30', totalEmDivida: 532100.00 },
        { id: 'loan-novo-002', produtoFinanceiro: 'Crédito Empresas', inicio: '2020-04-01', fim: '2030-04-01', totalEmDivida: 207700.00 },
      ],
    },
    {
      id: 'inst-sant',
      nome: 'Santander Portugal',
      totalEmDivida: 524560.00,
      loans: [
        { id: 'loan-sant-001', produtoFinanceiro: 'Crédito Habitação', inicio: '2021-05-15', fim: '2051-05-15', totalEmDivida: 395800.00 },
        { id: 'loan-sant-002', produtoFinanceiro: 'Crédito Automóvel', inicio: '2022-10-01', fim: '2027-10-01', totalEmDivida: 40760.00 },
        { id: 'loan-sant-003', produtoFinanceiro: 'Crédito Pessoal', inicio: '2024-01-20', fim: '2027-01-20', totalEmDivida: 88000.00 },
      ],
    },
    {
      id: 'inst-bpi',
      nome: 'Banco BPI',
      totalEmDivida: 614820.80,
      loans: [
        { id: 'loan-bpi-001', produtoFinanceiro: 'Crédito Habitação', inicio: '2016-06-01', fim: '2046-06-01', totalEmDivida: 487100.80 },
        { id: 'loan-bpi-002', produtoFinanceiro: 'Leasing Automóvel', inicio: '2023-03-01', fim: '2028-03-01', totalEmDivida: 65920.00 },
        { id: 'loan-bpi-003', produtoFinanceiro: 'Crédito Pessoal', inicio: '2024-07-15', fim: '2027-07-15', totalEmDivida: 61800.00 },
      ],
    },
    {
      id: 'inst-act',
      nome: 'Activobank',
      totalEmDivida: 312450.00,
      loans: [
        { id: 'loan-act-001', produtoFinanceiro: 'Crédito Habitação', inicio: '2020-12-01', fim: '2050-12-01', totalEmDivida: 278900.00 },
        { id: 'loan-act-002', produtoFinanceiro: 'Crédito Pessoal', inicio: '2025-01-10', fim: '2028-01-10', totalEmDivida: 33550.00 },
      ],
    },
    {
      id: 'inst-abk',
      nome: 'Abanca Portugal',
      totalEmDivida: 412935.00,
      loans: [
        { id: 'loan-abk-001', produtoFinanceiro: 'Crédito Habitação', inicio: '2019-08-20', fim: '2049-08-20', totalEmDivida: 354800.00 },
        { id: 'loan-abk-002', produtoFinanceiro: 'Crédito Empresas', inicio: '2022-03-15', fim: '2032-03-15', totalEmDivida: 58135.00 },
      ],
    },
  ],
};

export const mockComparisonReport: ComparisonReport = {
  mesAnterior: 'Maio 2026',
  mesAtual: 'Junho 2026',
  totalSaldoAnterior: 4872340.50,
  totalSaldoAtual: 4793215.80,
  totalValorPago: 79124.70,
  numInstituicoes: 7,
  numInstituicoesMatch: 6,
  numInstituicoesNovas: 0,
  numInstituicoesAusentes: 0,
  generatedAt: '2026-07-16T08:10:00Z',
  institutions: [
    {
      institutionId: 'inst-cgd',
      nome: 'Caixa Geral de Depósitos',
      saldoAnterior: 1245800.00,
      saldoAtual: 1223450.00,
      valorPago: 22350.00,
      variacaoPercent: -1.79,
      numEmprestimosAnterior: 4,
      numEmprestimosAtual: 4,
      novosEmprestimos: 0,
      emprestimosLiquidados: 0,
      status: 'match',
      loans: [
        { loanId: 'loan-cgd-001', produtoFinanceiro: 'Crédito Habitação', inicio: '2018-03-15', fim: '2048-03-15', saldoAnterior: 485200.00, saldoAtual: 483900.00, diferenca: 1300.00, status: 'activo' },
        { loanId: 'loan-cgd-002', produtoFinanceiro: 'Crédito Pessoal', inicio: '2022-06-01', fim: '2027-06-01', saldoAnterior: 28400.00, saldoAtual: 27200.00, diferenca: 1200.00, status: 'activo' },
        { loanId: 'loan-cgd-003', produtoFinanceiro: 'Crédito Automóvel', inicio: '2023-01-10', fim: '2028-01-10', saldoAnterior: 18600.00, saldoAtual: 17750.00, diferenca: 850.00, status: 'activo' },
        { loanId: 'loan-cgd-004', produtoFinanceiro: 'Crédito Habitação', inicio: '2020-09-20', fim: '2050-09-20', saldoAnterior: 713600.00, saldoAtual: 694600.00, diferenca: 19000.00, status: 'activo' },
      ],
    },
    {
      institutionId: 'inst-bcp',
      nome: 'Millennium BCP',
      saldoAnterior: 987450.25,
      saldoAtual: 965200.00,
      valorPago: 22250.25,
      variacaoPercent: -2.25,
      numEmprestimosAnterior: 3,
      numEmprestimosAtual: 3,
      novosEmprestimos: 0,
      emprestimosLiquidados: 0,
      status: 'match',
      loans: [
        { loanId: 'loan-bcp-001', produtoFinanceiro: 'Crédito Habitação', inicio: '2019-07-01', fim: '2049-07-01', saldoAnterior: 612000.00, saldoAtual: 609500.00, diferenca: 2500.00, status: 'activo' },
        { loanId: 'loan-bcp-002', produtoFinanceiro: 'Leasing Imobiliário', inicio: '2021-02-15', fim: '2036-02-15', saldoAnterior: 245000.00, saldoAtual: 243200.00, diferenca: 1800.00, status: 'activo' },
        { loanId: 'loan-bcp-003', produtoFinanceiro: 'Crédito Pessoal', inicio: '2023-08-01', fim: '2026-08-01', saldoAnterior: 130450.25, saldoAtual: 112500.00, diferenca: 17950.25, status: 'activo' },
      ],
    },
    {
      institutionId: 'inst-novo',
      nome: 'Novo Banco',
      saldoAnterior: 756200.00,
      saldoAtual: 739800.00,
      valorPago: 16400.00,
      variacaoPercent: -2.17,
      numEmprestimosAnterior: 2,
      numEmprestimosAtual: 2,
      novosEmprestimos: 0,
      emprestimosLiquidados: 0,
      status: 'match',
      loans: [
        { loanId: 'loan-novo-001', produtoFinanceiro: 'Crédito Habitação', inicio: '2017-11-30', fim: '2047-11-30', saldoAnterior: 534500.00, saldoAtual: 532100.00, diferenca: 2400.00, status: 'activo' },
        { loanId: 'loan-novo-002', produtoFinanceiro: 'Crédito Empresas', inicio: '2020-04-01', fim: '2030-04-01', saldoAnterior: 221700.00, saldoAtual: 207700.00, diferenca: 14000.00, status: 'activo' },
      ],
    },
    {
      institutionId: 'inst-sant',
      nome: 'Santander Portugal',
      saldoAnterior: 534890.75,
      saldoAtual: 524560.00,
      valorPago: 10330.75,
      variacaoPercent: -1.93,
      numEmprestimosAnterior: 3,
      numEmprestimosAtual: 3,
      novosEmprestimos: 0,
      emprestimosLiquidados: 0,
      status: 'match',
      loans: [
        { loanId: 'loan-sant-001', produtoFinanceiro: 'Crédito Habitação', inicio: '2021-05-15', fim: '2051-05-15', saldoAnterior: 398000.00, saldoAtual: 395800.00, diferenca: 2200.00, status: 'activo' },
        { loanId: 'loan-sant-002', produtoFinanceiro: 'Crédito Automóvel', inicio: '2022-10-01', fim: '2027-10-01', saldoAnterior: 42890.75, saldoAtual: 40760.00, diferenca: 2130.75, status: 'activo' },
        { loanId: 'loan-sant-003', produtoFinanceiro: 'Crédito Pessoal', inicio: '2024-01-20', fim: '2027-01-20', saldoAnterior: 94000.00, saldoAtual: 88000.00, diferenca: 6000.00, status: 'activo' },
      ],
    },
    {
      institutionId: 'inst-bpi',
      nome: 'Banco BPI',
      saldoAnterior: 623400.50,
      saldoAtual: 614820.80,
      valorPago: 8579.70,
      variacaoPercent: -1.38,
      numEmprestimosAnterior: 3,
      numEmprestimosAtual: 3,
      novosEmprestimos: 0,
      emprestimosLiquidados: 0,
      status: 'match',
      loans: [
        { loanId: 'loan-bpi-001', produtoFinanceiro: 'Crédito Habitação', inicio: '2016-06-01', fim: '2046-06-01', saldoAnterior: 489200.50, saldoAtual: 487100.80, diferenca: 2099.70, status: 'activo' },
        { loanId: 'loan-bpi-002', produtoFinanceiro: 'Leasing Automóvel', inicio: '2023-03-01', fim: '2028-03-01', saldoAnterior: 67400.00, saldoAtual: 65920.00, diferenca: 1480.00, status: 'activo' },
        { loanId: 'loan-bpi-003', produtoFinanceiro: 'Crédito Pessoal', inicio: '2024-07-15', fim: '2027-07-15', saldoAnterior: 66800.00, saldoAtual: 61800.00, diferenca: 5000.00, status: 'activo' },
      ],
    },
    {
      institutionId: 'inst-act',
      nome: 'Activobank',
      saldoAnterior: 312450.00,
      saldoAtual: 312450.00,
      valorPago: 0.00,
      variacaoPercent: 0.00,
      numEmprestimosAnterior: 2,
      numEmprestimosAtual: 2,
      novosEmprestimos: 0,
      emprestimosLiquidados: 0,
      status: 'anomalia',
      loans: [
        { loanId: 'loan-act-001', produtoFinanceiro: 'Crédito Habitação', inicio: '2020-12-01', fim: '2050-12-01', saldoAnterior: 278900.00, saldoAtual: 278900.00, diferenca: 0.00, status: 'activo' },
        { loanId: 'loan-act-002', produtoFinanceiro: 'Crédito Pessoal', inicio: '2025-01-10', fim: '2028-01-10', saldoAnterior: 33550.00, saldoAtual: 33550.00, diferenca: 0.00, status: 'activo' },
      ],
    },
    {
      institutionId: 'inst-abk',
      nome: 'Abanca Portugal',
      saldoAnterior: 412149.00,
      saldoAtual: 412935.00,
      valorPago: -786.00,
      variacaoPercent: 0.19,
      numEmprestimosAnterior: 2,
      numEmprestimosAtual: 2,
      novosEmprestimos: 0,
      emprestimosLiquidados: 0,
      status: 'anomalia',
      loans: [
        { loanId: 'loan-abk-001', produtoFinanceiro: 'Crédito Habitação', inicio: '2019-08-20', fim: '2049-08-20', saldoAnterior: 356000.00, saldoAtual: 354800.00, diferenca: 1200.00, status: 'activo' },
        { loanId: 'loan-abk-002', produtoFinanceiro: 'Crédito Empresas', inicio: '2022-03-15', fim: '2032-03-15', saldoAnterior: 56149.00, saldoAtual: 58135.00, diferenca: -1986.00, status: 'alterado' },
      ],
    },
  ],
};